import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Seo } from "../components/Seo";

export default function Register() {
  const { register } = useAuth();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    const r = await register(email, password, name);
    setLoading(false);
    if (r.ok) nav("/pricing");
    else setErr(r.error);
  };

  return (
    <div data-testid="register-page" className="min-h-screen flex items-center justify-center px-6 pt-24 pb-12">
      <Seo title="Create your locker" description="Join Dr. Cuts free, then unlock unlimited swing uploads with a $10/month membership." path="/register" />
      <div className="w-full max-w-md">
        <div className="overline">Open your locker</div>
        <h1 className="font-display text-5xl mt-3">Join Dr. Cuts.</h1>
        <p className="text-white/60 mt-2">Free to register. Upload access starts with membership.</p>

        <form onSubmit={submit} className="mt-10 space-y-4">
          <div>
            <label className="overline block mb-2" style={{color:"#A0B0A8"}}>Name</label>
            <input data-testid="register-name" required minLength={1} value={name} onChange={(e) => setName(e.target.value)} className="input-dark" placeholder="Jordan Spieth" />
          </div>
          <div>
            <label className="overline block mb-2" style={{color:"#A0B0A8"}}>Email</label>
            <input data-testid="register-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-dark" placeholder="you@golf.com" />
          </div>
          <div>
            <label className="overline block mb-2" style={{color:"#A0B0A8"}}>Password</label>
            <input data-testid="register-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="input-dark" placeholder="Min 6 characters" />
          </div>
          {err && <div data-testid="register-error" className="text-sm text-red-400">{err}</div>}
          <button data-testid="register-submit" disabled={loading} className="btn-primary w-full">{loading ? "Creating..." : "Create account"}</button>
        </form>

        <div className="mt-8 text-sm text-white/60">
          Already a member? <Link to="/login" className="text-[#C9A227] underline-offset-4 hover:underline" data-testid="register-to-login">Log in</Link>
        </div>
      </div>
    </div>
  );
}
